module.exports = __webpack_public_path__ + "img/fuel.0f1179c4.gif";